import React from 'react';

import { BrowserRouter as Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './state/store';
import AppRoutes from './Routes/Routes';


function App() {
  return (
      <Provider store={store}>
        <React.Suspense>
          <Router>
            <AppRoutes/>
          </Router>
        </React.Suspense>
      </Provider>
  );
}

export default App;
